module.exports = __webpack_public_path__ + "static/media/warehouse.9d5392ef.svg";